import { render, staticRenderFns } from "./LaudoRenovabio.vue?vue&type=template&id=3ca725a7&scoped=true&lang=pug"
import script from "./LaudoRenovabio.vue?vue&type=script&lang=js"
export * from "./LaudoRenovabio.vue?vue&type=script&lang=js"
import style0 from "./LaudoRenovabio.vue?vue&type=style&index=0&id=3ca725a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca725a7",
  null
  
)

export default component.exports